import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  input,
  output,
} from '@angular/core';
import { Params } from '@angular/router';
import { DepartmentsService } from '@qaroni-app/departments/services/departments.service';

@Component({
  selector: 'qaroni-departments-filter',
  templateUrl: './departments-filter.component.html',
  styleUrl: './departments-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DepartmentsFilterComponent implements OnInit {
  readonly companyID = input<number>(0);
  readonly multiple = input<boolean>(false);
  readonly departmentFilterLabel = input<string>($localize`Departamento`);
  readonly queryParamName = input<string>('departmentId');

  readonly queryParamsChange = output<Params>();

  private departmentService = inject(DepartmentsService);
  public departments$ = this.departmentService.getDepartmentsSubject$();

  ngOnInit(): void {
    const params = {
      page: 1,
      pagination: 1000,
    };

    this.departmentService.list(this.companyID(), params);
  }

  public onQueryParamsChange(params: Params): void {
    this.queryParamsChange.emit(params);
  }
}
